"use client";

import dynamic from "next/dynamic";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

const TopNav = dynamic(() => import("@/components/shared/TopNav"));
const Footer = dynamic(() => import("@/components/shared/Footer"));

export default function NotFound() {
  const router = useRouter();
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    // Referrer is empty if the user typed the URL or landed from a bookmark
    setCanGoBack(document.referrer !== "");
  }, []);

  const handleBackToConverting = () => {
    if (canGoBack) {
      router.back();
    } else {
      router.push("/");
    }
  };

  return (
    <div>
      <TopNav />
      <main>
        <div className="py-24 pt-36 pb-12 sm:pb-24 flex flex-col justify-center items-center">
          <div className="flex flex-col items-center justify-center gap-6">
            <div className="flex flex-col items-center justify-center">
              <h1 className="md:!text-7xl leading-[46px] md:leading-[78px] pt-2 tracking-tighter !text-[32px] !font-semibold max-w-[980px] text-wrap text-center text-[#0D2A4C] lg:px-9">
                Well, This is Awkward… You’ve Hit a Dead Inbox.
              </h1>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-2.5 z-10">
              <button
                onClick={handleBackToConverting}
                className="bg-[#2A8DFF] hover:bg-[#2A8DFF]/90 active:outline-1 active:outline-[#2A8DFF] active:bg-[#2A8DFF] !cursor-pointer px-8 text-center lg:py-[18px] py-[14px] rounded-[100px]"
              >
                <p className="text-lg text-white font-semibold">
                  Back to converting
                </p>
              </button>
              <Link
                href="https://listkit.io/pricing"
                className="bg-[#F8F9FA] cursor-pointer hover:bg-white active:outline-1 active:outline-[#F8F9FA] active:bg-[#F8F9FA] w-full text-center sm:w-fit px-8 lg:py-[18px] py-[14px] border border-[#0D2A4C08] rounded-[100px]"
              >
                <p className="text-lg text-[#0D2A4C] font-semibold">
                  See Pricing
                </p>
              </Link>
            </div>
          </div>
        </div>
        <div className="w-full flex justify-center z-0">
          <p className="text-[#F8F9FA] text-[200px] leading-48 lg:leading-96 lg:text-[500px] font-semibold tracking-tight">
            404
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
